export function getCurrencySymbol(country) {
  const currencySymbols = {
    "Singapore": "S$",
    "Malaysia": "RM",
    "Hong Kong": "HK$",
    "Taiwan": "NT$",
    "Middle East": "﷼", // Common symbol for Riyal used in multiple Middle Eastern countries
    "Philippines": "₱",
    "Myanmar": "K",
    "Sri Lanka": "Rs",
    "India": "₹",
    "Other": "$" // Default or general symbol
  };

 // return currencySymbols[country] || "$";
 return "S$";
}

export const formatNumberWithCustomSymbol = (number, country = '') => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const formattedNumber = formatter.format(number);
  //return `${formattedNumber} ${getCurrencySymbol(country)}`;
  return `${formattedNumber} S$`; // Default to Singapore Dollar for now
}
